<script lang="ts">
import { onMounted, watch, ref } from "vue";
import { UmbracoAPIs } from "../../clients/search/src/umbracoAPIs";
import {
  ISiteSearchResult,
  ResultOptions,
  SiteSearchCriteria,
  TagFilter
} from "../../clients/search/src/models";
export default {
  props: {
    endPoint: {
      type: String,
      required: true,
      default: ""
    },
    parentid: {
      type: Number,
      required: true,
      default: -1
    },
    tags: {
      required: false,
      default: null
    },
    images: {
      type: Array<string>,
      required: false,
      default: () => []
    },
    keyword: {
      type: String,
      required: false,
      default: ""
    },
    additionalFields: {
      type: Array<string>,
      required: false,
      default: () => []
    },
    additionalFieldsMultiLingual: {
      type: Array<string>,
      required: false,
      default: () => []
    },
    years: {
      type: Array,
      required: false,
      default: () => []
    },
    page: {
      type: Number,
      required: false,
      default: 0
    },
    pagesize: {
      type: Number,
      required: false,
      default: 20
    },
    sortOrder: {
      type: String,
      required: false,
      default: ""
    },
    sortType: {
      type: String,
      required: false,
      default: "Score"
    },
    sortIsDesc: {
      type: Boolean,
      required: false,
      default: false
    },
    language: {
      type: String,
      required: false,
      default: ""
    },
    personalisationGroupIds: {
      type: String,
      required: false,
      default: ""
    }
  },
  emits: ["change"],
  setup(props, ctx) {
    const result = ref({} as ISiteSearchResult);
    const loading = ref(false);
    const error = ref(false);
    const language = props.language;

    const getFilterTags = tags => {
      const tagFilters: TagFilter[] = [];
      for (let tag = 0; tag < tags.length; tag++) {
        const element: any = tags[tag];
        const tagFilter = tagFilters.find(
          o => o.tagGroupId === element.categoryId
        );
        if (tagFilter) {
          tagFilter.tags.push(element.tagId);
        } else {
          tagFilters.push({
            tagGroupId: element.categoryId,
            tags: [element.tagId]
          });
        }
      }
      return tagFilters;
    };

    const fetchResources = async (resetPage = true) => {
      loading.value = true;
      error.value = false;
      try {
        let setPage = props.page;
        if (setPage < 1 || resetPage) {
          setPage = 1;
        }

        let searchKeyword = props.keyword;
        if (searchKeyword.length < 3) {
          searchKeyword = "";
        }

        const resultOptions: ResultOptions = {
          pageNumber: setPage,
          pageSize: props.pagesize,
          sortField: props.sortOrder,
          sortDesc: props.sortIsDesc,
          sortType: props.sortType
        };

        const genericSearchRequest: SiteSearchCriteria = {
          keyword: searchKeyword,
          nodeStartId: props.parentid,
          resultOptions,
          images: props.images,
          additionalFields: props.additionalFields,
          additionalFieldsMultiLingual: props.additionalFieldsMultiLingual,
          tagFilters: getFilterTags(props.tags),
          language: props.language,
          personalisationGroups: props.personalisationGroupIds.split(","),
          secondarySortOptions: {
            sortField: "pageTitle",
            sortDesc: false,
            sortType: "String"
          }
        };

        const SearchRepository = new UmbracoAPIs(props.endPoint);
        const options = {
          body: genericSearchRequest
        };

        result.value = await SearchRepository.search(options);
        loading.value = false;
        ctx.emit("change", result.value);
      } catch (e) {
        console.log(e);
        error.value = true;
      }
    };

    onMounted(() => {
      fetchResources();
    });

    watch(
      [
        () => props.parentid,
        () => props.keyword,
        () => props.tags,
        () => props.years,
        () => props.sortOrder,
        () => props.sortType,
        () => props.sortIsDesc
      ],
      () => {
        fetchResources();
      }
    );

    watch([() => props.page, () => props.pagesize], () => {
      fetchResources(false);
    });

    return () =>
      ctx.slots.search({
        error: error.value,
        result: result.value,
        loading: loading.value
      });
  }
};
</script>
